<div class="site-footer">
    <div class="container">
        <div class="site-footer__widgets">
            <div class="row">
                <div class="col-12 col-md-6 col-lg-4">
                    <app-footer-contacts></app-footer-contacts>
                </div>
                <div class="col-12 col-md-6 col-lg-4">
                    <div class="row">
                        <div class="col-6">
                            <app-footer-links [header]="'information' | t:'Information'" [links]="[
                                {key: 'help-centre', label: 'Help Centre',           url: '/help'},
                                {key: 'faq', label: 'FAQ',                   url: '/faq'},
                                {key: 'refund-policy', label: 'Refund Policy',         url: '/refund-policy'},
                                {key: 'privacy-policy', label: 'Privacy Policy',        url: '/privacy'},
                                {key: 'terms-and-conditions', label: 'Terms And Conditions',  url: '/terms'}
                            ]"></app-footer-links>
                        </div>
                        <div class="col-6">
                            <app-footer-links [header]="'shopping-made-easy' | t:'Shopping Made Easy'" [links]="shoppingLinks$ | async"></app-footer-links>
                        </div>
                    </div>

                    <!-- The way in for sellers: the sell page (/sell), whose "Apply to sell" leads on to the form.
                         Only on the seller side of the site (sellerPage$); a shopper's footer has no sell box. -->
                    <div class="merchant-cta" *ngIf="sellerPage$ | async">
                        <svg class="merchant-cta__icon" width="26" height="26" viewBox="0 0 24 24" aria-hidden="true">
                            <path d="M4.2 4h15.6L21.5 9H2.5z" />
                            <path d="M2.5 9h19v1a3.17 3.17 0 0 1-6.33 0 3.17 3.17 0 0 1-6.34 0A3.17 3.17 0 0 1 2.5 10z" />
                            <path d="M4 12.8V20h16v-7.2M10 20v-4.5h4V20" />
                        </svg>
                        <div class="merchant-cta__text">
                            <span class="merchant-cta__title">{{ 'sell-on-primehat' | t:'Sell on PrimeHat' }}</span>
                            <span class="merchant-cta__sub">{{ 'sell-on-primehat-text' | t:'List your products and reach shoppers. Free to apply.' }}</span>
                        </div>
                        <a class="btn btn-primary btn-sm merchant-cta__button" routerLink="/sell">
                            {{ 'become-a-merchant' | t:'Become a Merchant' }}
                            <app-icon name="arrow-rounded-right-6x9" size="6x9"></app-icon>
                        </a>
                    </div>
                </div>
                <div class="col-12 col-md-12 col-lg-4">
                    <app-footer-newsletter class="site-footer__widget"></app-footer-newsletter>
                </div> 
            </div>
        </div>

        <div class="site-footer__bottom">
            <!-- Who owns the shop, from the Company section. It said the shop was "powered by" itself,
                 with rel="canonical" on a link, and named no owner. -->
            <div class="site-footer__copyright">
                <ng-container *ngIf="company$ | async as c; else brandOnly">
                    <ng-container *ngIf="c.legalName; else brandOnly">
                        {{ 'footer-copyright' | t:'© {year} {company}. All rights reserved.':{ year: year, company: c.legalName } }}
                        <span class="site-footer__attribution">{{ 'brand-is-a-brand-of' | t:'{brand} is a brand of {company}.':{ brand: c.brandName, company: c.legalName } }}</span>
                        <span class="site-footer__attribution" *ngIf="c.registrationNumber">{{ 'listing-shop-registration-number' | t:'Registration number {number}':{ number: c.registrationNumber } }}.</span>
                    </ng-container>
                </ng-container>
                <ng-template #brandOnly>© {{ year }} {{ brand.name }}</ng-template>
            </div>
            <!-- What the checkout genuinely accepts (app-footer-payments): nothing is shown until there is something. -->
            <div class="site-footer__payments footer-payments">
                <app-footer-payments></app-footer-payments>
            </div>
        </div>
    </div>
    <app-totop></app-totop>
</div> 